module.exports = __webpack_public_path__ + "static/media/leslie-app-inverted.8467abd9.png";